export default __webpack_public_path__ + "static/media/silver-volume.d4c31cbf.png";